import script from "./MoreInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreInfo.vue?vue&type=script&setup=true&lang=js"

import "./MoreInfo.vue?vue&type=style&index=0&id=3341b4ec&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3341b4ec"]])

export default __exports__